<script>
    import axios from 'axios';
    import KSInfiniteTree from '../InfiniteTree/InfiniteTree.vue';
    import {Listeners} from "../../../../../constants/listeners";
    import {nextTick} from "vue";
    import AdaptersDialog from "../../../../../component/adapters/Dialog.vue";
    import {store} from "../../../store";
    import InputText from "primevue/inputtext";
    import RadioButton from "primevue/radiobutton";

    export default {
        data() {
            return {
                name: 'KSCreateNodeFromFilter',
                loading: false,
                error: null,
                nodeName: null,
                pid: 0,
                filter: null,
                keys: 0,
                selectedTo: [],
                nodes: [],
                superTree: {},
                store: store,
            }
        },
        methods: {
            save() {
                let self = this;
                if(!this.nodeName){
                    this.error = this.$t('lang.cluster.enter_folder_name');
                    return false;
                }

                self.loading = true;

                let data = {pid: this.pid, name: this.nodeName};
                if(this.keys === 0){
                    data['ids'] = this.selectedTo;
                }

                axios({
                    method: 'post',
                    url: this.getApiUrl,
                    withCredentials: true,
                    data: data
                })
                    .then(function (response) {
                        self.onClose();

                        let fromNode = self.$parent.$_tree.getNodeById(self.getSelectNode.id);
                        self.$parent.$_tree.updateNode(fromNode, response.data.from);

                        let parentNode = self.$parent.$_tree.getNodeById(self.pid);
                        self.$parent.$_tree.appendChildNode(response.data.to, parentNode);

                        if (!parentNode.state.open) {
                            self.$parent.$_tree.openNode(parentNode, {
                                asyncCallback(){
                                    self.store.mutations.setNodesInfo(self.$parent.$_tree.getNodesInfo());
                                    self.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
                                    self.$emitter.emit(Listeners.KS_FILTER_CLEAR);
                                    self.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
                                }
                            });
                        } else {
                            self.store.mutations.setNodesInfo(self.$parent.$_tree.getNodesInfo());
                            self.$emitter.emit(Listeners.CLUSTER_REFRESH_FILTER);
                            self.$emitter.emit(Listeners.KS_FILTER_CLEAR);
                            self.$emitter.emit(Listeners.KS_TABLE_CLEAR_SELECTED_TO);
                        }
                    })
                    .catch(function (error) {
                        self.loading = false;
                        self.error = error.response.data.message;
                    });
            },
            onOpen() {
                let self = this;
                nextTick(() => {
                    self.$refs["modalInput"].$el.focus()
                });
                this.error = null;
                this.loading = false;
                this.nodeName = null;
            },
            onClose() {
                this.$emitter.emit(this.getListenerPopupCreateCloseId);
            }
        },
        computed: {
            getSelectNode() {
                return this.store.getters.selectNode();
            },
            getUid() {
                return this.store.getters.uid();
            },
            getApiUrl() {
                return this.$config.API_URL + '/clustering/node/' + this.getUid + "/" + this.getSelectNode.id + "/by_filter?filter=" + this.filter;
            },
            apiUrl() {
                return this.$config.API_URL + '/clustering/' + 'node/' + this.getUid + '/simple'
            },
            filteredNodes() {
                return this.nodes.filter(n => {
                    return n.id !== -1 && n.id !== -2;
                });
            },
            getListenerPopupCreateOpenId() {
                return Listeners.CLUSTER_POPUP_CREATE_NODE_FROM_FILTER_OPEN;
            },
            getListenerPopupCreateCloseId() {
                return Listeners.CLUSTER_POPUP_CREATE_NODE_FROM_FILTER_CLOSE;
            },
        },
        mounted() {
            let self = this;

            this.$emitter.on(Listeners.CLUSTER_CREATE_NODE_FROM_FILTER, data => {
                self.superTree = self.$parent.$_tree;

                self.filter = data.filter;
                self.selectedTo = data.selectedTo;
                if(self.getSelectNode.id === -1 || self.getSelectNode.id === -2){
                    self.pid = 0;
                }else{
                    self.pid = self.getSelectNode.id;
                }

                self.keys = 0;
                self.$emitter.emit(self.getListenerPopupCreateOpenId);
            });
        },
        components: {
            'ks-infinite-tree': KSInfiniteTree,
            AdaptersDialog,
            InputText,
            RadioButton,
        }
    }
</script>
<template>
    <AdaptersDialog
        :listener-id="getListenerPopupCreateOpenId"
        :listener-close-id="getListenerPopupCreateCloseId"
        :header="$t('lang.cluster.create_gr_by_flt')"
        :callback-on-show="onOpen"
        :loading="loading"
        :error-message="error"
        :callback-agree="save"
        :button-agree-label="$t('lang.main.btn.create')"
        :callback-on-hide="onClose"
    >
        <template #content>
            <div class="field">
                <label for="folder_name" class="required">{{ $t('lang.cluster.folder_name') }}</label>
                <InputText v-model="nodeName" ref="modalInput" @keyup.enter="save" inputId="folder_name" />
            </div>
            <div v-if="selectedTo.length > 0" class="formgroup-inline">
                <label>{{ $t('lang.cluster.keys') }}</label>
                <div class="field-radiobutton">
                    <RadioButton v-model="keys" inputId="only_selected" :value="0" />
                    <label for="only_selected">{{ $t('lang.cluster.only_selected', [selectedTo.length]) }}</label>
                </div>
                <div class="field-radiobutton">
                    <RadioButton v-model="keys" inputId="under_the_filter" :value="1" />
                    <label for="under_the_filter">{{ $t('lang.cluster.under_the_filter') }}</label>
                </div>
            </div>
            <div class="field">
                <label for="choose_move_folder" class="required">{{ $t('lang.cluster.root_folder') }}</label>
                <ks-infinite-tree :tree="superTree" v-model:pid="pid" :node-disabled="[-1,-2]"></ks-infinite-tree>
            </div>
        </template>
    </AdaptersDialog>
</template>
